const counters: Record<string, number> = {};

interface Logger {
    log(...args: unknown[]): void;
    error(...args: unknown[]): void;
}

const log = function (name: string, ...args: unknown[]) {
    const counter = counters[name] || 0;
    counters[name] = counter + 1;

    name = `${name}: ${counter} %c"${args[0]}"`;
    args[0] = 'color: #ca2117;';

    console.log(name, ...args);
};

const isEnabled = function (block: string): boolean {
    const itemKey = `logSvpPlayer${block}`;

    // check global first
    // @ts-expect-error not statically typed
    if (window[itemKey] === true) {
        return true;
    }

    // fix Safari errors when cookies are disabled
    try {
        if (!window.localStorage) {
            return false;
        }

        return window.localStorage.getItem(itemKey) === 'true';
    } catch {
        return false;
    }
};

export default function (block = 'SVP'): Logger {
    const error = (...args: unknown[]) => console.error('SVP Player:', ...args);

    if (isEnabled(block)) {
        return {
            log(...args: unknown[]) {
                if (typeof args[0] === 'function') {
                    args[0](log.bind(this, block));
                } else {
                    log(block, ...args);
                }
            },
            error,
        };
    }

    return {
        log() {},
        error,
    };
}
